<template>
  <b-card class="m-3">
    <template #header>
      <h6 class="mb-0 text-center">
        <span class="titulo-sagres font-weight-bold">Dados do documento/solicitação</span>
        <btn-voltar />
      </h6>
    </template>
    <span style="float: left"><strong>Assunto: </strong>{{ solicitacao.Assunto }}</span><br />
    <span style="float: left"><strong>Protocolo/Processo: </strong>{{ solicitacao.CodProtProc }}</span><br />
    <span style="float: left"><strong>Arquivo: </strong>
      <b-link @click="baixarArquivo(solicitacao)" :disabled="baixandoArquivo">{{ solicitacao.NomeArquivo }}</b-link>
      <b-spinner v-if="baixandoArquivo" small />
    </span><br />
    <span style="float: left"><strong>Situação: </strong>{{ solicitacao.Situacao }}</span><br />
    <span style="float: left"><strong>Data de Solicitação:
      </strong>{{ formatData(solicitacao.DataSolicitacao) }}</span><br />
    <div v-if="saPassivelDeAssinatura" class="d-flex flex-column align-items-start mt-3">
      <b-button size="sm" @click="abrirModalAssinatura">Asssinar</b-button>
    </div>
    <b-modal id="assinatura-modal" size="md" button-size="sm" centered header-bg-variant="secondary"
      header-text-variant="light" header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop
      no-close-on-esc>
      <template v-slot:modal-header="">
        <h5>Assinar Anexos</h5>
      </template>

      <b-row>
        <b-col cols="6" class="">
          <b-form-group id="input-group-type" label-size="md" label="Tipo" label-for="type">
            <b-form-select v-model="type">
              <b-form-select-option value="S" selected>Senha</b-form-select-option>
              <b-form-select-option value="T">Token</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6" class="">
          <b-form-group v-if="type === 'S'" id="input-group-password" label-size="md" label="Senha"
            label-for="password">
            <b-form-input type="text" style="width: 0; height: 0; padding: 0; border: 0"></b-form-input>
            <b-form-input v-model="senha" type="password" autocomplete="new-password"></b-form-input>
          </b-form-group>
          <b-form-group v-else id="input-group-type" label-size="md" label="Certificado" label-for="type">
            <b-form-select v-model="thumbprint">
              <b-form-select-option value="0" disabled selected>Selecione</b-form-select-option>
              <b-form-select-option v-for="cert in certificados" :key="cert.thumbprint" :value="cert.thumbprint">{{
                  cert.subjectName
              }}</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <template v-slot:modal-footer="{ cancel }">
        <b-progress :value="curValueBar" :max="maxValueBar" v-if="maxValueBar" class="w-50"></b-progress>
        <b-button size="sm" :disabled="showLoading" variant="secondary" @click="confirmar()" class="w-25">
          <b-spinner v-if="showLoading" small />
          Confirmar
        </b-button>
        <b-button size="sm" variant="outline-secondary" :disabled="showLoading" @click="cancel()" class="w-20">
          Cancelar
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import { store } from "@/store";
import solicitacoesAssinaturaService from "@/services/processos-eletronicos/solicitacoesAssinaturaService"
import LacunaWebPKI from "web-pki";

import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import { UtilsTS } from '@/utilsts';
export default {
  name: "detalhes-solicitacao-assinatura",
  mixins: [UtilsTS],
  props: ["solicitacao"],
  components: {
    BtnVoltar
  },
  data() {
    return {
      opcoesAssinatura: [
        { text: 'Certificado digital', value: 'T' },
        { text: 'Minha senha', value: 'S' },
      ],
      //modal assinatura
      type: "S",
      showLoading: false,
      senha: "",
      thumbprint: 0,
      pki: null,
      token: null,
      certificados: null,
      //barra de progresso de assinatura
      curValueBar: null,
      maxValueBar: null,
      listarCertificados: null,

      baixandoArquivo: false,
    }
  },
  methods: {
    abrirModalAssinatura() {
      this.$bvModal.show("assinatura-modal");
    },
    async assinarComSenha() {
      const data = new FormData();
      data.append("codArquivo", this.solicitacao.CodArquivoDigital);
      data.append("senha", this.senha);
      const response = await solicitacoesAssinaturaService.assinarEnviarDocumento(data);
      if (response && response.status === 200) {
        this.$bvModal.hide('assinatura-modal');
      } else {
        if (response.data?.msg) throw response.data.msg;
        else throw "Erro assinando documento";
      }
    },
    async iniciarAssinaturaToken() {
      const data = new FormData();
      data.append("codArquivoDigital", this.solicitacao.CodArquivoDigital);
      const response = await solicitacoesAssinaturaService.iniciarAssinaturaToken(data);
      if (response && response.status === 200) {
        this.token = response.data;
      } else {
        if (response.data?.msg) throw response.data.msg;
        else throw "Erro iniciando assinatura";
      }
    },
    async finalizarAssinaturaToken() {
      let t = this.token;
      const response = await solicitacoesAssinaturaService.finalizarAssinaturaToken(t);
      if (response && response.status !== 200) {
        if (response.data?.msg) throw response.data.msg;
        else throw "Erro finalizando assinatura";
      }
    },
    limparProgressBar() {
      this.curValueBar = null;
      this.maxValueBar = null;
    },
    //modal assinatura
    async confirmar() {
      const data = new FormData();
      this.showLoading = true;
      if (this.type == "S") {
        this.curValueBar = 1;
        this.maxValueBar = 3;
        try {
          await this.assinarComSenha();
          this.curValueBar = 2;
          this.$toast.success(
            `Documento assinado com sucesso`
          );
          this.token = null
          this.senha = ""
          this.$router.push('/processo-eletronico/historico-solicitacoes-assinatura')
        } catch (e) {
          console.error("Erro ao confirmar assinatura com senha", e);
          this.$toast.error(e);
        } finally {
          this.showLoading = false;
          this.$bvModal.hide("assinatura-modal");
          this.senha = '';
          this.limparProgressBar();
        }
      } else {
        this.curValueBar = 1;
        this.maxValueBar = 50;
        try {
          await this.iniciarAssinaturaToken();
          this.maxValueBar = 4 + 1;
          this.curValueBar++;

          this.signWithRestPki(this.token);
        } catch (e) {
          this.$toast.error(e);
          this.showLoading = false;
          this.limparProgressBar();
        }
      }
    },
    signWithRestPki(token) {
      this.pki
        .signWithRestPki({
          token: token.Token,
          thumbprint: this.thumbprint,
        })
        .success((res) => {
          this.curValueBar++;
          this.completeSignature();
        })
        .error((error) => {
          console.error("Falha no signWithRestPki", error);
          this.onWebPkiError("Erro ao assinar documento.", error);
          this.limparProgressBar();
        });
    },
    async completeSignature() {
      try {
        await this.finalizarAssinaturaToken();
        this.$toast.success(
          `Documento assinado com sucesso`
        );
        this.token = null
        this.senha = ""
        this.$router.push('/processo-eletronico/historico-solicitacoes-assinatura')
      } catch (e) {
        console.error("Erro ao completar assinatura com token", e);
        this.$toast.error(e);
      } finally {
        this.showLoading = false;
        this.$bvModal.hide("assinatura-modal");
        this.limparProgressBar();
      }
    },
    loadCertificates: function () {
      this.pki
        .listCertificates({
          filter: this.pki.filters.isWithinValidity,
        })
        .success((certs) => {
          this.certificados = certs;
          this.listarCertificados = setTimeout(() => {
            this.loadCertificates();
          }, 5000);
        });
    },
    onWebPkiNotInstalled: function (status, msg, arg3, arg4) {
      this.$toast.error("Extensão WebPKI não encontrada");
    },
    onWebPkiFail: function (status, msg, arg3, arg4) {
      this.$toast.error("Extensão WebPKI retornou uma falha.");
      this.limparProgressBar();
    },
    onWebPkiError(message, error, origin) {
      this.$toast.error("Ocorreu um erro ao executar o WebPKI.");
      this.showLoading = false;
      this.limparProgressBar();
    },
    async baixarArquivo(item) {
      this.baixandoArquivo = true
      const response = await solicitacoesAssinaturaService.baixarArquivoAssinatura(item.CodArquivoDigital)
      if (response && response.status == 200) {
        this.download(item.NomeArquivo, response.data);
      } else {
        if (response && response.status === 404)
          this.$toast.error("Erro ao obter o arquivo");
        else if (response.data.msg) this.$toast.error(response.data.msg);
        else this.$toast.error("Erro ao obter o arquivo");
      }
      this.baixandoArquivo = false
    },
  },
  computed: {
    saPassivelDeAssinatura() {
      return this.solicitacao && this.solicitacao.Situacao && (this.solicitacao.Situacao.toLowerCase() == 'não assinado')
    }
  },
  beforeDestroy() {
    if (this.listarCertificados) clearTimeout(this.listarCertificados);
  },
  async mounted() {
    try {
      store.blockScreen = true;

      this.pki = new LacunaWebPKI(process.env.VUE_APP_LACUNA_LICENSE);
      this.pki.init({
        restPkiUrl: process.env.VUE_APP_REST_PKI_URL,
        ready: this.loadCertificates,
        notInstalled: this.onWebPkiNotInstalled,
        defaultFail: this.onWebPkiError,
      });
    } finally {
      store.blockScreen = false;
    }
  }
}
</script>
